import Pagination from "./lib/Pagination";

export default Pagination;